import { useMemo } from 'react';
import { useMediaSize } from '../../tools/utils';
var useButtonWidth = function (variant, disableFullWidthSmDown, fullWidthMd, buttonSize) {
    var isSmDown = useMediaSize('SmDown');
    var isMdOnly = useMediaSize('MdOnly');
    var isLink = useMemo(function () { return variant === 'link'; }, [variant]);
    var width = useMemo(function () {
        if (isSmDown && !isLink && buttonSize !== 'sm') {
            return disableFullWidthSmDown ? 'fit-content' : '100%';
        }
        if (isMdOnly && !isLink && buttonSize !== 'sm') {
            return fullWidthMd ? '100%' : 'fit-content';
        }
        return 'fit-content';
    }, [
        isLink,
        disableFullWidthSmDown,
        fullWidthMd,
        isSmDown,
        isMdOnly,
        buttonSize,
    ]);
    return { width: width };
};
export { useButtonWidth };
//# sourceMappingURL=useButtonWidth.js.map